/**
 * RFC 7807 problem details payload returned by API error responses.
 */
export interface ProblemDetails {
    readonly type?: string | null;
    readonly title?: string | null;
    readonly status?: number | null;
    readonly detail?: string | null;
    readonly instance?: string | null;
}
